class CartLineItemVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.selects = this.querySelectorAll('.cart-item__variant-select');
    this.line = this.dataset.line;
    this.currentVariantId = this.dataset.variantId;
    this.quantity = this.dataset.quantity;
    
    this.selects.forEach(select => {
      select.addEventListener('change', this.onVariantChange.bind(this));
    });
  }

  onVariantChange() {
    // Get selected options
    const selectedOptions = {};
    this.selects.forEach(select => {
      const optionName = select.dataset.optionName;
      selectedOptions[optionName] = select.value;
    });

    // Find matching variant
    const selectedVariant = this.variants.find(variant => {
      return Object.keys(selectedOptions).every(optionName => {
        const optionIndex = parseInt(
          Array.from(this.selects).find(s => s.dataset.optionName === optionName).dataset.optionIndex
        );
        return variant[`option${optionIndex + 1}`] === selectedOptions[optionName];
      });
    });

    if (selectedVariant && selectedVariant.id != this.currentVariantId) {
      // Check if variant is available
      if (!selectedVariant.available) {
        const errorElement = document.querySelector(`[data-line-item-error][data-line="${this.line}"]`);
        if (errorElement) {
          errorElement.textContent = 'This variant is out of stock';
        }
        return;
      }
      this.updateCartVariant(selectedVariant.id);
    }
  }

  updateCartVariant(newVariantId) {
    // Show loading state
    const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
    if (cartItems) {
      cartItems.classList.add('is-loading');
    }

    // First, remove the current line item
    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        line: this.line,
        quantity: 0,
        sections: this.getSectionsToRender().map(section => section.section),
        sections_url: window.location.pathname
      })
    })
    .then(response => response.json())
    .then(() => {
      // Then add the new variant with the same quantity
      return fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: newVariantId,
          quantity: parseInt(this.quantity),
          sections: this.getSectionsToRender().map(section => section.section),
          sections_url: window.location.pathname
        })
      });
    })
    .then(response => response.json())
    .then(parsedState => {
      // Update cart sections
      this.getSectionsToRender().forEach(section => {
        const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);
        if (elementToReplace && !parsedState.errors) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      });

      // Update cart counters
      if (typeof updateCartCounters === 'function') {
        updateCartCounters();
      }
      
      // Update free shipping bar
      if (typeof updateFreeShipping === 'function') {
        updateFreeShipping();
      }

      // Handle errors
      if (parsedState.errors) {
        const errorElement = document.querySelector(`[data-line-item-error][data-line="${this.line}"]`);
        if (errorElement) {
          errorElement.textContent = parsedState.errors || parsedState.description;
        }
      }
    })
    .catch(error => {
      console.error('Error updating cart variant:', error);
      const errorElement = document.querySelector(`[data-line-item-error][data-line="${this.line}"]`);
      if (errorElement) {
        errorElement.textContent = 'Error updating variant. Please try again.';
      }
    })
    .finally(() => {
      if (cartItems) {
        cartItems.classList.remove('is-loading');
      }
    });
  }

  getSectionsToRender() {
    const cartDrawer = document.querySelector('cart-drawer');
    const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
    const getSectionData = (id, section, selector) => ({ id, section, selector });

    if (cartDrawer && mainCartId) {
      return [
        getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
        getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
        getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
      ];
    } else if (cartDrawer) {
      return [getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")];
    } else if (mainCartId) {
      return [
        getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
        getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
      ];
    }
    return [];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
}

customElements.define('cart-line-item-variant-picker', CartLineItemVariantPicker);

